import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { NXMenu, NXSearch } from "../../icons";
import logo from "../../assets/logo_white.svg";
import { RootState } from "../../redux/rootReducer";
import enumChoice, { getEnumLabel } from "../../enum";
import { useState } from "react";
import systemIndex from "./systemIndex";
import { InputField } from "../common";

function Header({
  setSidebarOpen,
  sidebarOpen,
}: {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarOpen: boolean;
}) {
  const me = useSelector((state: RootState) => state.auth.me);
  let location = useLocation();

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredItems, setFilteredItems] = useState<typeof systemIndex>([]);

  const pathname = location.pathname;
  const navigate = useNavigate();

  const toggleSideBar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (query) {
      const results = systemIndex.filter(
        (item) =>
          item.title.toLowerCase().includes(query) ||
          item.keywords.some((keyword) => keyword.includes(query))
      );
      setFilteredItems(results);
    } else {
      setFilteredItems([]);
    }
  };

  
  return (
    <header className={`w-full overflow-hidden z-40 ${pathname==='/dashboard/products/add-new-product' || '/dashboard/products/add-new-product' ? '' : 'sticky top-0'}`}>
      {/* Desktop Nav */}
      <div className="hidden z-50 md:flex w-full h-[100px] bg-white backdrop:blur md:px-5 lg:px-10 items-center justify-between border-b border-[#EEEFF2]">
        <div className="flex gap-5">
          {sidebarOpen && (
            <button className="block mh:hidden text-black w-10" onClick={toggleSideBar}>
              <NXMenu />
            </button>
          )}

          {pathname === "/dashboard" ? (
            <div>
              <h1 className="font-nunito font-[900] md:text-lg lg:text-2xl">
                Hi, {me?.user?.fullName}
              </h1>
              <p className="font-lato font-lato-body text-base-400 md:text-sm lg:text-md">
                Let's check your store today !
              </p>
            </div>
          ) : (
            <div>
              <h1 className="font-nunito font-nunito-h1 text-2xl">
                {pathname.slice(1).split("/")[0].charAt(0).toUpperCase() +
                  pathname.slice(1).split("/")[0].slice(1)}
              </h1>
            </div>
          )}
        </div>

        <div className="flex items-center gap-5">
          <div className="relative ">
            <NXSearch className="absolute top-1/2 left-4 transform -translate-y-1/2" />
            <InputField
              type="text"
              placeholder="Search..."
              className="p-[12px] text-[14px] bg-secondary-50 rounded-lg border-none outline-none ps-[3.1rem] w-[100%]"
              onChange={handleSearchChange}
            />

            {filteredItems.length > 0 && (
              <ul
                className="bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto fixed top-[80px] left-25 right-0 mx-auto w-[40%] z-[1000]"
              >
                {filteredItems.map((item, index) => (
                  <li
                    key={index}
                    className="px-4 py-2 hover:bg-secondary-100 cursor-pointer"
                    onClick={() => {
                      navigate(item.url);
                      setFilteredItems([]);
                    }}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            )}


          </div>
          {/* <div className="flex">
            <NXIconNotificationActive />
            <NXMessageActive />
          </div> */}
          <hr className="h-[40px] w-[1px] bg-secondary-100" />
          <div className="flex gap-5">
            <div className="flex flex-col justify-center">
                <h3 className="font-nunito font-[900] md:text-sm lg:text-xl capitalize">
                {me?.user?.fullName}
                </h3>
              <span className="font-lato font-[400] md:text-sm text-base-400 hidden md:block">
                {getEnumLabel(enumChoice.useRole, me?.user?.role)}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile nav */}
      <div className="block md:hidden px-7 sticky top-0 left-0 bg-white z-40 pb-3">
        <div className="py-3 flex items-center justify-between gap-3">
            <div className="flex gap-2 items-center">
            <button className="text-black w-7" onClick={toggleSideBar}>
              <NXMenu />
            </button>
            <img
              src={logo}
              alt="NXTBN logo"
              className="w-[6rem] p-2 rounded-full bg-[rgb(39,114,0)]"
            />
            </div>
          <div className="flex gap-3 items-center">
            <h3 className="font-nunito font-nunito-h1">  {me?.user?.fullName}</h3>
            <div className="h-[30px] aspect-square rounded-full bg-secondary-500"></div>
          </div>
        </div>
        <div className="relative">
          <NXSearch className="absolute top-1/2 left-4 transform -translate-y-1/2" />
          <input
            type="text"
            placeholder="Search..."
            className="px-[12px] py-2 text-[14px] bg-secondary-100 rounded-lg border-none outline-none ps-[3.1rem] w-full"
          />
        </div>
      </div>
    </header>
  );
}

export default Header;
